export const ADD_PAYMENT_PURPOSE_REQUEST = "ADD_PAYMENT_PURPOSE_REQUEST";
export const ADD_PAYMENT_PURPOSE_SUCCESS = "ADD_PAYMENT_PURPOSE_SUCCESS";
export const ADD_PAYMENT_PURPOSE_FAILURE = "ADD_PAYMENT_PURPOSE_FAILURE";
export const CLEAR_PAYMENT_PURPOSES_ERROR = "CLEAR_PAYMENT_PURPOSES_ERROR";
export const FETCH_PAYMENT_PURPOSES_REQUEST = "FETCH_PAYMENT_PURPOSES_REQUEST"; // Ensure this is added correctly
export const FETCH_PAYMENT_PURPOSES_SUCCESS = "FETCH_PAYMENT_PURPOSES_SUCCESS";
export const FETCH_PAYMENT_PURPOSES_FAILURE = "FETCH_PAYMENT_PURPOSES_FAILURE";
export const UPDATE_PAYMENT_PURPOSES_REQUEST =
  "UPDATE_PAYMENT_PURPOSES_REQUEST";
export const UPDATE_PAYMENT_PURPOSES_SUCCESS =
  "UPDATE_PAYMENT_PURPOSES_SUCCESS";
export const UPDATE_PAYMENT_PURPOSES_FAILURE =
  "UPDATE_PAYMENT_PURPOSES_FAILURE";
export const DELETE_PAYMENT_PURPOSES_REQUEST =
  "DELETE_PAYMENT_PURPOSES_REQUEST";
export const DELETE_PAYMENT_PURPOSES_SUCCESS =
  "DELETE_PAYMENT_PURPOSES_SUCCESS";
export const DELETE_PAYMENT_PURPOSES_FAILURE =
  "DELETE_PAYMENT_PURPOSES_FAILURE";
